import { FC, useEffect, useRef, useState } from 'react';
import {Box, Button, useMediaQuery, styled, Tab, Tabs, Typography, useTheme, CircularProgress} from '@mui/material';
import { utils } from 'ethers';
import { useAppDispatch, useAppSelector } from 'state/hooks';
import { icons } from 'config/constants/assets';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { getBalanceInEther, } from 'utils';
import { useWeb3React } from '@web3-react/core';
import { useStakeEstimateInfo,} from 'hooks/useStakeInfo';
import { useFtmPrice } from 'hooks/useFTMPrice';
import { getRouters } from 'utils/deployTokens';
import { fetchStakerInfoAsync,  } from 'state/actions';
import { useGetTokensLogoPiniata2 } from 'hooks/useGetDeployedTokenImage';
import { getTokenInfo } from 'utils/tokens';
import TabPanel from 'components/Earn/Stakings/TabPanel';
import CountDown from 'components/Earn/Stakings/CountDown';
import ContainedInfoBox from "../common/InfoBox/ContainedInfoBox";
import {InfoLabelBegin, InfoLabelEnd} from "../common/Typography/InfoLabel";
import LogoBox from "../common/LogoContainer/LogoBox";

const Container = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    marginTop: '10px',
    background: "rgba(42,49,57, 0.4)",
    border: '1px solid #5E6980',
    display: 'flex',
    maxWidth: '900px',
    borderRadius: '10px',
    flexDirection: 'column',
    [theme.breakpoints.up('xs')]: {
      padding: '0px 16px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '20px 32px',
    },
  }));


const PoolName2 = styled(Typography)(({ theme }) => ({
    fontFamily: 'Prompt',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'left',
  
    [theme.breakpoints.up('xs')]: {
      display: 'block',
      textAlign: 'left',
      whiteSpace: 'nowrap',
    },
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left'
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'left'
    },
  }));



  const PoolAprLabel = styled(Typography)(({ theme }) => ({
    fontFamily: 'Prompt',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '16px',
    maxWidth: '200px',
    whiteSpace: 'break-spaces',
    textAlign: 'left',
    width: '100%',
    marginLeft: '10px',
    [theme.breakpoints.up('xs')]: {
      display: 'block',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    [theme.breakpoints.up('sm')]: {
      whiteSpace: 'break-spaces',
    },
    [theme.breakpoints.up('md')]: {
      display: 'block',
      textAlign: 'center',
      whiteSpace: 'break-spaces',
    },
  }));

  const PoolAprValue = styled(Typography)(({ theme }) => ({
    fontFamily: 'Prompt',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '16px',
    maxWidth: '200px',
    whiteSpace: 'break-spaces',
    textAlign: 'left',
    width: '100%',
    marginLeft: '10px',
    [theme.breakpoints.up('xs')]: {
      display: 'block',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    [theme.breakpoints.up('sm')]: {
      whiteSpace: 'break-spaces',
    },
    [theme.breakpoints.up('md')]: {
      display: 'block',
      textAlign: 'center',
      whiteSpace: 'break-spaces',
    },
  }));



const TokenSymbol = styled(Typography)(({ theme }) => ({
  fontFamily: 'Prompt',
  fontStyle: 'normal',
  fontWeight: '300',
  fontSize: '16px',
  lineHeight: '24px',
  maxWidth: '300px',
  whiteSpace: 'break-spaces',
  textAlign: 'end',
  width: '100%',

  [theme.breakpoints.up('xs')]: {
    display: 'block',
    margin: 'auto',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  [theme.breakpoints.up('sm')]: {
    whiteSpace: 'break-spaces',
  },
  [theme.breakpoints.up('md')]: {
    display: 'block',
    textAlign: 'center',
    whiteSpace: 'break-spaces',
  },
}));


// modal body
const ModalBody = styled(Box)(({theme}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  gap: '10px',
  [theme.breakpoints.up('xs')]: {
    flexDirection: 'column',
    padding: '10px',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    padding: '0px',
  },
}));

interface Props {
    tokenInfo: any,
    poolInfo: any,

}

function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        style={{width: '100%'}}
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box display={'flex'} sx={{width: '100%'}}>
            {children}
          </Box>
        )}
      </div>
    );
  }


const StakerPool: FC<Props> = ({ tokenInfo, poolInfo}) => {
  const { pendingTxHash } = useAppSelector((state) => state.modal);
  const { selectedChainId, isWalletChecked } = useAppSelector((state) => state.chain);
  const ftmPrice = useFtmPrice(Number(selectedChainId));

  const pendingTxHashRef: { current: string | undefined } = useRef();
  pendingTxHashRef.current = pendingTxHash;
  const [tokenPrice, setTokenPrice] = useState<string>("--");
  const [amm, setAmm] = useState<string>("--");
  const [tokenImage, setTokenImage] = useState<string>("");
  const [lockedLps, setLockedLps] = useState<Number>(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { account } = useWeb3React();
  const images = useGetTokensLogoPiniata2(0)
  const [value, setValue] = useState(0);
  const [stakedDFund, setStakedDfund] = useState<number>(0);
  const [totalStaked, setTotalStaked] = useState<number>(0);
  const [tvl, setTvl] = useState<number>(0);
  const [apr, setApr] = useState<number>(0);
  const [dailyApr, setDailyApr] = useState<number>(0);
  const [pendingRewards, setPendingRewards] = useState<number>(0);
  const [lockTime, setLockTime] = useState<number>(0)
  const [counter, setCounter] = useState<number>(0)
  const {stat,loading} = useStakeEstimateInfo(Number(selectedChainId), poolInfo, counter, tokenInfo, ftmPrice)
  const info = stat;
  const isClaimable = Math.floor((new Date()).getTime() / 1000) > lockTime

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if( info  ){
      try{
        setApr(info.aprYear)
        setDailyApr(info.aprYear/ 365)
        setTvl(Number(utils.formatUnits(info.totalStaked, info.decimals))*info.stakeTokenPriceFTM* ftmPrice) //pp
        setStakedDfund(Number(utils.formatUnits(info.userStaked, info.decimals)))
        setPendingRewards((Number(utils.formatUnits(info.pendingRewards, 18))))
        if(Number(getBalanceInEther(info.pendingRewards)) < 0 )
          setPendingRewards(0)
    
        setLockTime(Number(info.stakeTime) + Number(info.lockTime))
      }
      catch(err){
        // 
      }

    }
  }, [info, account, ]);;

const onCloseModal = () => {
    setIsExpanded(false)
  };

  useEffect(() => {
    if( images && info ){
        setTokenImage(images[info?.info?.tokenAddress]?.img)
    }
}, [images, info]);


useEffect(() => {
if( ftmPrice && info ){
    setTokenPrice((info?.tokenPriceFTM * ftmPrice).toFixed(info?.tokenPriceFTM < 0.001 ? 6 : 3))
}
}, [ftmPrice, info]);

useEffect(() => {
    if( info ) {
        dispatch(fetchStakerInfoAsync(Number(selectedChainId),account ? account : "", ftmPrice, info));
    }
}, [info, selectedChainId]);

useEffect(() => {
if( info ){ 
  const routers = getRouters(Number(selectedChainId))
  setLockedLps(Number(info?.lockLps))
  for( let i = 0; i < routers.length; i+=1 )
  {
    if( routers[i].address === info?.info?.router ){
        setAmm(routers[i].name)
        return
    }
  }
}
}, [info, selectedChainId]);

const getTokInfo = (address: string) : any => {
    return getTokenInfo(address)
};
const onUpdate = () => {
    setCounter(counter+1);
};

  const truncate = (str: string, n: number) => {
    return str?.length > n ? `${str.substr(0, n ) } ... ${str.substr(str.length - n, n) }`: str;
  };
  return (
    <> <Container>
        {/* body */}
        <ModalBody sx={{position: 'relative', justifyContent: 'space-between'}}>
            <>
                <Box  display='flex' onClick={() => {setIsExpanded(!isExpanded)}}  position='absolute' sx={{bottom: 18, right: {xs: 0, md: -50 } ,
                    border: '1px solid #5E6980', borderRadius: '25px', padding: '10px', background: '#2A3139', cursor: 'pointer'}}>
                        <ArrowBackIosNewIcon sx={{width: '15px', height: '15px', transform: !isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'}}/>
                </Box>
            </>
            
            <Box display='flex' flexDirection='column'  alignItems='center' gap='10px' sx={{ border: '0px solid red', height: '100%', width: '100%', maxWidth: '140px', overflow: getTokInfo(poolInfo?.stakingToken)?.isRounded ? 'clip' : '', position: 'relative'}}>
                {poolInfo &&
                    <>

                        <LogoBox imageUrl={getTokInfo(poolInfo?.stakingToken)?.tokenImage}
                                 sx={{ width: '60px',
                                     height: '60px',
                                     borderRadius: getTokInfo(poolInfo?.stakingToken)?.isRounded ? '50px' : '0px',}}
                        imageStyles={{objectFit: 'fill'}}
                        />
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={()=>{    navigator.clipboard.writeText(getTokInfo(poolInfo?.stakingToken)?.address);}}
                            style={{maxHeight: '24px', borderRadius: '0px', display: tokenInfo?.info?.deployerAddress ? "" : "none", width: '140px', maxWidth: '140px',}}

                        >

                          <Typography style={{fontSize: '11px', color: "lightgray"}} color='primary' variant={'h5'} >{truncate(getTokInfo(poolInfo?.stakingToken)?.address, 4)}
                          </Typography>
                          <FileCopyIcon style={{marginLeft: '2px',maxHeight:"18px", width: 'auto'}}/>
                        </Button>

                        </>
                }
            </Box>
            <Box display='flex' flexDirection='column' gap={'10px'} justifyContent='center' alignItems='center' sx={{background: "rgba(6,1,1,0.3)",  minHeight: '77px', height: '100%', borderRadius: '10px', minWidth: '150px'}}>

              <Box display={'flex'} flexDirection={'row'}>
                <TokenSymbol>
                  {getTokInfo(poolInfo?.stakingToken)?.tokenName.toUpperCase()}

                </TokenSymbol>
              </Box>
              <Box display={'flex'} flexDirection={'row'}>
                <PoolAprLabel>
                  APR
                </PoolAprLabel>
                <PoolAprValue>
                    {loading ? (<CircularProgress size={20} sx={{ color: 'white' }} />) : info?.apr ? info?.apr < 0 ? "Ended" : info?.apr < 1 ? `${info?.apr.toFixed(3)}%` : `${info?.apr.toFixed(0)}%` : ''}
                </PoolAprValue>
              </Box>
            </Box>
            <Box display='flex' gap={'10px'} sx={{flexDirection: {xs: 'column'}}}>    
                <ContainedInfoBox  sx={{minHeight: '34px',minWidth: '200px'}}>
                                <InfoLabelBegin sx={{minWidth: '120px'}}>
                                    TVL:  
                                </InfoLabelBegin>
                                <InfoLabelEnd>
                                    {loading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : '$'+tvl.toFixed(2)}
                                </InfoLabelEnd>
                </ContainedInfoBox>
                <ContainedInfoBox  sx={{minHeight: '34px',minWidth: '200px'}}>
                                <InfoLabelBegin sx={{minWidth: '120px'}}>
                                    Deposit Fee:  
                                </InfoLabelBegin>
                                <InfoLabelEnd>
                                    {info ? `${info?.depositFee}%` : `--.--`}
                                </InfoLabelEnd>
                </ContainedInfoBox>
            </Box>
            <Box display='flex' gap={'10px'} sx={{flexDirection: {xs: 'column'}}}>    
                <ContainedInfoBox  sx={{minHeight: '34px',minWidth: '200px'}}>
                                <InfoLabelBegin sx={{minWidth: '120px'}}>
                                    Your Stake
                                </InfoLabelBegin>
                                <InfoLabelEnd>
                                  {`${Number(Number(stakedDFund || 0).toFixed(4)).toLocaleString()}`}
                                </InfoLabelEnd>
                </ContainedInfoBox>
                <ContainedInfoBox  sx={{minHeight: '34px',minWidth: '200px'}}>
                                <InfoLabelBegin sx={{minWidth: '120px'}}>
                                    Rewards:  
                                </InfoLabelBegin>
                                <InfoLabelEnd>
                                    {pendingRewards?.toFixed(2)}
                                </InfoLabelEnd>
                </ContainedInfoBox>
            </Box>

        </ModalBody>
        {isExpanded && 
                <>
                    <Box mt={2} sx={{width: '100%', height: '2px', background: '#5E6980'}}/>
                    <Box display='flex' flexDirection={isMobile ? 'column' : 'row'} alignItems='center' justifyContent='space-between'>
                        <Box mt={2} gap={'25px'} display='flex' sx={{border: '0px solid red'}}>
                            <ContainedInfoBox sx={{justifyContent: 'center', width: '140px'}}>
                                Time until no tax
                            </ContainedInfoBox>
                            <Box display='flex' flexDirection='row'  alignItems='center' justifyContent='center' gap='10px' sx={{height: '100%', maxWidth: '200px', border: '0px solid red', position: 'relative', minWidth: '100px'}}>
                                <ContainedInfoBox sx={{minHeight: '34px',minWidth: '152px'}}>
                                    <img src={icons.timeIcon}  style={{width: '22px', height: '22px', minWidth: '20px', objectFit: 'fill'}}/>
                                    <PoolName2 sx={{border: '0px solid red'}}>
                                    <CountDown lockTime={lockTime}/>
                                    </PoolName2>
                                </ContainedInfoBox>
                            </Box>
                        </Box>
                        <Box mt={2} display='flex' gap='5px'>
                            <ContainedInfoBox  sx={{minHeight: '34px',minWidth: '200px'}}>
                                    <InfoLabelBegin sx={{minWidth: '130px'}}>
                                        Early withdraw tax
                                    </InfoLabelBegin>
                                    <InfoLabelEnd>
                                        { `10%`}
                                    </InfoLabelEnd>
                            </ContainedInfoBox>
                        </Box>
                    </Box>
                    <Box mt={2} sx={{display: 'flex'}} flexDirection='column' justifyContent='center' alignItems='center'>
                        <Box display='flex' flexDirection='row' justifyContent='center' alignItems='center' sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} sx={{width: '100%'}} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="Stake" {...a11yProps(0)} />
                            <Tab label="Unstake" {...a11yProps(1)} />
                            <Tab label="Claim" {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <Box mt={2} display='flex' sx={{width: '100%'}}>
                        <CustomTabPanel value={value} index={0}>
                            <TabPanel key={1} type='Stake'  onUpdate={onUpdate} pool={poolInfo} info={info} isClaimable={isClaimable}/>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <TabPanel key={2} type='Unstake' onUpdate={onUpdate} pool={poolInfo} info={info} isClaimable={isClaimable} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={2}>
                            <TabPanel key={3} type='Claim'  onUpdate={onUpdate} pool={poolInfo} info={info} isClaimable={isClaimable}/>
                        </CustomTabPanel>
                        </Box>
                    </Box>

                </>
            }
        </Container>
    </>
  );
};

export default StakerPool;
